import { render, staticRenderFns } from "./ParcellesTabIcon.vue?vue&type=template&id=1a443713"
import script from "./ParcellesTabIcon.vue?vue&type=script&lang=js"
export * from "./ParcellesTabIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports